import {assembleReportJobQuery} from './shared/reportJobFunctions';
import {setSystemToLowercase} from './shared/serverFunctions';

/**
 * Report Job Config             - Get Configuration for all Report Jobs
 * Report Jobs                   - Report Jobs List
 * Job Download                  - Download Report Job
 * Job Files                     - Get Report Job Files
 * Job Status                    - Get Status of Report Job
 *
 */
export const RESOURCES = {
    'ReportJobConfig': {
        GET_ONE: function (params) {
            let system = setSystemToLowercase();
            return {
                'type': 'item',
                'method': 'GET',
                'title': 'Report Job Config',
                'uri': localStorage.getItem('server') + '/api/v5/report/job/' + system + '/spec'
            }
        },
    },
    'ReportJobs': {
        GET_LIST: function (params) {
            let system = setSystemToLowercase();
            let query = assembleReportJobQuery(params);
            return {
                'type': 'list',
                'method': 'GET',
                'title': 'Report Jobs',
                'uri': localStorage.getItem('server') + '/api/v5/report/job/' + system + '/list' + query
            }
        },
        GET_ONE: function (params) {
            let system = setSystemToLowercase();
            return {
                'type': 'item',
                'method': 'GET',
                'title': 'Report Job',
                'uri': localStorage.getItem('server') + '/api/v5/report/job/' + system + '/get/' + params.id
            }
        },
        CREATE: function (params) {
            let system = setSystemToLowercase();
            return {
                'method': 'POST',
                'data': params.data,
                'uri': localStorage.getItem('server') + '/api/v5/report/job/' + system + '/submit'
            }
        },
    },
    'ReportJobDownload': {
        GET_ONE: function (params) {
            let system = setSystemToLowercase();
            return {
                'type': 'item',
                'method': 'GET',
                'title': 'Download Report Job File',
                'uri': localStorage.getItem('server') + '/api/v5/report/job/' + system + '/download/' + params.filename
            }
        },
    },
    'ReportJobFiles': {
        GET_ONE: function (params) {
            let system = setSystemToLowercase();
            return {
                'type': 'item',
                'method': 'GET',
                'title': 'Report Job Files',
                'uri': localStorage.getItem('server') + '/api/v5/report/job/' + system + '/files/' + params.id
            }
        },
    },
    'ReportJobStatus': {
        GET_ONE: function (params) {
            let system = setSystemToLowercase();
            return {
                'type': 'item',
                'method': 'GET',
                'title': 'Report Job Status',
                'uri': localStorage.getItem('server') + '/api/v5/report/job/' + system + '/stat/' + params.filename
            }
        },
    }
};

export default (type, resource, params) => {

    /**
     * @param {string} type Request type, e.g. GET_LIST
     * @param {string} resource Resource name, e.g. "ScheduledReports"
     * @param {Object} payload Request parameters. Depends on request type
     * @returns {Object} RESOURCES object
     */
    return (type, resource, params) => {
        return RESOURCES;
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/fuseJobsResourceMap.js